import React, { Component } from 'react';
import { Route } from "react-router-dom";

import Auth from "auth/Auth";
import history from 'routes/History/history';
import { AUTHENTICATED_HOME, NOT_AUTHENTICATED_HOME } from 'routes/constants';

import Pages from "layouts/Pages/Pages.jsx";
import Entry from "layouts/Entry/Entry.jsx";
import store from "store";
import { onRouteChange } from "reducers/application/applicationActions";

const handleAccesibility = (needAuth, props) => {
    const auth = new Auth();
    if (needAuth === true && !auth.isAuthenticated()) {
        history.push(NOT_AUTHENTICATED_HOME);
        return <Pages {...props} />;
    } else {
        if (needAuth === false && auth.isAuthenticated()) {
            history.push(AUTHENTICATED_HOME);
            return <Entry {...props} />;
        }
    }
    return null;
}

const AuthRoute = ({ component: Component, ...rest }) => {
    // alert("Route change")

    return (
        <Route {...rest} render={(props) => {
            store.dispatch(onRouteChange(props));
            let resComp = handleAccesibility(rest.data.needAuth, props);
            if (resComp != null) {
                return resComp;
            }
            return <Component {...props} />;
        }} />
    )
}

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/routes/AuthRoute/AuthRoute.jsx